export default __webpack_public_path__ + "static/media/2.7b093a15.jpg";